export const ignoredSentryErrors = [
  "Network Error",
  "timeout of 0ms exceeded",
  "Non-Error promise rejection captured with keys: currentTarget, isTrusted, target, type",
  "Loading chunk",
  "Unexpected token '<'",
  /^application '@ottu-mf\/(navigation|frontend)' died in status LOADING_SOURCE_CODE/,
  /^application '@ottu-mf\/(navigation|frontend)' died in status LOADING_SOURCE_CODE: undefined is not an object \(evaluating 'n.bootstrap'\)/,
];

export const SINGLE_SPA_CSS_TIMEOUT_ERROR_MESSAGE_REGEX =
  /"single-spa-css: While mounting '.*', loading CSS from URL (https?:\/\/[^ ]+) timed out after \d+ms"/;

export const MERCHANT_ADMIN_ROLE = "Merchantadmin";

export const EVENT_PLUGIN_PATHS = ["/events", "/event"];

export const PRIMARY_IMPORT_MAP = {
  imports: {
    "single-spa":
      "https://fastly.jsdelivr.net/npm/single-spa@5.9.5/lib/system/single-spa.min.js",
    vue: "https://fastly.jsdelivr.net/npm/vue@2.7.16/dist/vue.min.js",
    "vue-router":
      "https://fastly.jsdelivr.net/npm/vue-router@3.6.5/dist/vue-router.min.js",
  },
  integrity: {
    "https://fastly.jsdelivr.net/npm/single-spa@5.9.5/lib/system/single-spa.min.js":
      "sha384-gYQcI4+5k86VjzMv8lURpCSLYcxdlJ3iQUp2b4YtQzhb8scHcvDKlcHAxibEDPwl",
    "https://fastly.jsdelivr.net/npm/vue@2.7.16/dist/vue.min.js":
      "sha384-YVYXhPGIH/Gmcr0W5Rin4PcpcsG1a4pcdUUod1CnbDEJut7XiUaJtSlNKeRLJBPk",
    "https://fastly.jsdelivr.net/npm/vue-router@3.6.5/dist/vue-router.min.js":
      "sha384-/NExOjjk+Jjk5ZvMGKDUq/QxHVEJxhJXBBEb9AVSjc1zeQUYhG9cLvz1pY1/QrQF",
  },
};

export const FALLBACK_IMPORT_MAP = {
  imports: {
    "single-spa":
      "https://cdnjs.cloudflare.com/ajax/libs/single-spa/5.9.5/system/single-spa.min.js",
    vue: "https://cdnjs.cloudflare.com/ajax/libs/vue/2.7.16/vue.min.js",
    "vue-router":
      "https://cdnjs.cloudflare.com/ajax/libs/vue-router/3.6.5/vue-router.min.js",
  },
  integrity: {
    "https://cdnjs.cloudflare.com/ajax/libs/single-spa/5.9.5/system/single-spa.min.js":
      "sha384-gYQcI4+5k86VjzMv8lURpCSLYcxdlJ3iQUp2b4YtQzhb8scHcvDKlcHAxibEDPwl",
    "https://cdnjs.cloudflare.com/ajax/libs/vue/2.7.16/vue.min.js":
      "sha384-YVYXhPGIH/Gmcr0W5Rin4PcpcsG1a4pcdUUod1CnbDEJut7XiUaJtSlNKeRLJBPk",
    "https://cdnjs.cloudflare.com/ajax/libs/vue-router/3.6.5/vue-router.min.js":
      "sha384-/NExOjjk+Jjk5ZvMGKDUq/QxHVEJxhJXBBEb9AVSjc1zeQUYhG9cLvz1pY1/QrQF",
  },
};

export const PRIMARY_CDN_PACKAGES = [
  {
    url: "https://fastly.jsdelivr.net/npm/systemjs@6.15.1/dist/system.min.js",
    integrity:
      "sha384-r9HC22A0YSpgej9r98rRYlZ1+dD3MHvccNdh5DJpf6sTvSH7y4sHHZ+FS3Rjt/xO",
  },
  {
    url: "https://fastly.jsdelivr.net/npm/systemjs@6.15.1/dist/extras/amd.min.js",
    integrity:
      "sha384-eZ1E4eG7aqSbMQ+RSpo8Klw4L6/B5BWnw01omNC93ZCdUbX551CvZ+6t36Jip+Sp",
  },
];

export const FALLBACK_CDN_PACKAGES = [
  {
    url: "https://cdnjs.cloudflare.com/ajax/libs/systemjs/6.15.1/system.min.js",
    integrity:
      "sha384-r9HC22A0YSpgej9r98rRYlZ1+dD3MHvccNdh5DJpf6sTvSH7y4sHHZ+FS3Rjt/xO",
  },
  {
    url: "https://cdnjs.cloudflare.com/ajax/libs/systemjs/6.15.1/extras/amd.min.js",
    integrity:
      "sha384-eZ1E4eG7aqSbMQ+RSpo8Klw4L6/B5BWnw01omNC93ZCdUbX551CvZ+6t36Jip+Sp",
  },
];

export const ALLOWED_DOMAINS = [
  "https://fastly.jsdelivr.net/",
  "https://cdnjs.cloudflare.com/",
];

// Public page route mapping with regex patterns
export const PUBLIC_PAGE_ROUTES = {
  checkout: {
    matchRoute: /^\/(en|ar)\/checkout\/[a-f0-9]+\/?$/,
    extractId: /\/([a-f0-9]+)\/?$/,
  },
};
